import { GraphQLFormattedError } from 'graphql';

export const isExpiredTokenError = (
  graphQLErrors: ReadonlyArray<GraphQLFormattedError>
): boolean => {
  return graphQLErrors.some(
    ({ extensions }) => extensions?.code === 'UNAUTHENTICATED'
  );
};
